import styled from 'styled-components';
import HappyBookNowPayLaterSvg from './happyBookNowPayLater.svg';

const HappyBookNowPayLaterIcon = styled(
  HappyBookNowPayLaterSvg as React.SFC<React.SVGProps<SVGSVGElement>>,
)`
  width: ${props => props.width || '1.5rem'};
  height: ${props => props.height || '1.5rem'};
  fill: ${props => props.fill || props.theme.colors.ash.base};
  margin: ${props => props.margin};
`;

export default HappyBookNowPayLaterIcon;
